'use client';
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import HeroSection from './components/HeroSection';
import DiagnosticsSection from './components/DiagnosticsSection';
import ResourceSection from './components/ResourceSection';
import ReferralSection from './components/ReferralSection';
import StickyCTA from './components/StickyCTA';

export default function HematoPage() {
  return (
    <main style={{ background: '#F4F7FA', color: '#3B4856' }}>
      <Header />
      <HeroSection />
      <DiagnosticsSection />
      <ResourceSection />
      <ReferralSection />
      <Footer />
      <StickyCTA />
    </main>
  );
}